import { render, staticRenderFns } from "./UsageHistoryTable.vue?vue&type=template&id=f28c93de"
import script from "./UsageHistoryTable.vue?vue&type=script&lang=js"
export * from "./UsageHistoryTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports